export const openmodel = ( navigate, from) => {
  navigate("/agreement", { state: `${from}` });
  window.scrollTo(0, 0);
};

export const homePage = ( navigate ) => {
  navigate("/");
};
